import { db } from './db.js'

async function getUnsyncedItems() {
  try {
    const index = db.transaction('items').store.index('syncneeded')
    const keyRangeValue = IDBKeyRange.bound(1, 1, false, false)
    let cursors = await index.getAll(keyRangeValue)
    return cursors
  } catch (e) {
    return []
  }
}

async function cleanupItems(currentShiftUUID) {
  try {
    const tx = db.transaction('items');
    let allTrx = await tx.store.getAll()
    for await (const cursor of allTrx) {
      //console.log('CLEANUP TRX:', currentShiftUUID, cursor)
      if (cursor.shiftUUID === currentShiftUUID || cursor.syncneeded) continue
      else {
        await db.delete('items', cursor.uuid)
      }
    }

  } catch (e) {
    console.log('cleanupItems', e)
  }
}

async function getItemDB(uuid) {
  try {
    const index = db.transaction('items').store
    let item = await index.get(uuid)
    return item
  } catch (e) {
    return null
  }
}

async function getShiftItemsDB(shiftUUID) {
  try {
    const index = db.transaction('items').store.index('shiftUUID')
    const keyRangeValue = IDBKeyRange.bound(shiftUUID, shiftUUID, false, false)
    let cursors = await index.getAll(keyRangeValue)
    return cursors
  } catch (e) {
    return []
  }
}

async function getDocumentItemsDB(documentUUID) {
  try {
    const index = db.transaction('items').store.index('documentUUID')
    const keyRangeValue = IDBKeyRange.bound(documentUUID, documentUUID, false, false)
    let cursors = await index.getAll(keyRangeValue)
    return cursors
  } catch (e) {
    return []
  }
}

async function storeItem(item) {
  let itemObj = JSON.parse(JSON.stringify(item))
  if (db == null) return null
  if (itemObj.syncneeded == null) itemObj.syncneeded = 0
  try {
    await db.put('items', itemObj)
  } catch (e) {
    console.log('put error item', e)
  }
}

export {
  storeItem,
  getUnsyncedItems,
  getItemDB,
  getShiftItemsDB,
  cleanupItems,
  getDocumentItemsDB
}